import { RootState } from "../index";

export const getCustomerUploadStatus = (state: RootState) =>
    state.customerUpload.status;

export const getCustomerUploadData = (state: RootState) =>
    state.customerUpload.data;

export const getCustomerUploadError = (state: RootState) =>
    state.customerUpload.error;